import React from 'react'
import { renderChildren } from './helpers'

export class EduThen extends React.PureComponent {
  render() {
    return renderChildren(this.props)
  }
}
